import React, { useRef, useEffect } from 'react'
import { takeLast, dropLast } from 'ramda'
import Img from 'gatsby-image'
import Slider from "react-slick"

const settings = {
  centerMode: true,
  infinite: true,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 1900,
  className: "center",
  pauseOnHover: false,
  slidesToShow: 5,
  easing: 'ease-in-out'
}


const StartupCarousel = ({ companies }) => {
  const carouselEl = useRef(null)

  const onPrevClick = () => {
    carouselEl.current.slickPrev()
  }
  const onNextClick = () => {
    carouselEl.current.slickNext()
  }

  useEffect(
    () => {
      const timer = setTimeout(() => carouselEl.current.slickNext(), 500)
      return () => {
        clearTimeout(timer)
      }
    }, [])

  // Comanies are sorted by `display_order` and `name` fields.
  // We hide the first slide for the initial slide-in animation.
  // Because of the animation, if we do not re-arrange the companies,
  // the first company that is supposed to be displayed in the beginning will be hidden by the animation and will appear last in the carousel.
  const rearrangedCompanies = [...takeLast(1, companies), ...dropLast(1, companies)]

  return (
    <div className="startup-carousel">
      <span
        className="startup-carousel-arrow arrow-prev"
        onClick={onPrevClick}
      />
      <div className="slider-container">
        <Slider {...settings} ref={carouselEl}>
          {rearrangedCompanies.map(({ node }) => (
            <div key={node.name}>
              <a href={node.url}>
                <Img loading="eager" fluid={node.carousel_logo.childImageSharp.fluid} />
              </a>
            </div>
          ))}
        </Slider>
      </div>
      <span
        className="startup-carousel-arrow arrow-next"
        onClick={onNextClick}
      />
    </div>
  )
}

export default StartupCarousel
